import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {LogisticsVehicle} from "../../../logistics-vehicle/models/logistics-vehicle.model";
import {MapFactoryService} from "../../services/map.service";
import {MapsCommonService} from "../../services/mapsCommon.service";
import {TaskModel} from "../../../tasks/models/task.model";
import {ResizeService} from "../../../commons/services/resize-service.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {AgentsService} from "../../../agents/services/agents-service.service";
import {TaskPurposeType} from "../../../commons/types/task-purpose.type";
import {escapeHtml} from "../../../commons/utils/html-escape.util";

export class AgentPerformanceMapComponent implements IController {
  agent: any;
  agentLocationCoords: any;
  tasks: TaskModel[];
  irregularities: any;
  highlightedTaskId: string;
  highlightedIrregularityId: string;
  selectedTaskId: string;
  agentDraggable: any;
  hiddenAgentIds: any;
  logisticsVehicles: LogisticsVehicle[];
  isUseDaySequenceAsTaskIndex: boolean;
  isCenterByAgent: boolean;
  geoRoutes: any;
  routes: any;
  onHighlightedChanged: Function;
  onHiddenAgentIdsChange: Function;
  onAgentLocationChange: Function;
  onTasksOrderChange: Function;
  taskTooltipTemplateUrl: string;
  actualTrackingStops: any;
  generalizedLocationCircles: any[];

  private mapRef: any;
  private mapTypeIds: any = {
    roadmap: 'ROADMAP',
    satellite: 'SATELLITE'
  }
  private infowindow: any;
  private inActiveStatuses: any;
  private siteLocation: any;
  public taskInfoWindow: any;
  public polylineInfoWindow: any;
  private map: any;
  private agentMarker: any;
  private agentEvents: any;
  private depotEvents: any;
  private myLocation: any = undefined;
  private taskMarkers: any = [];
  private relatedTaskMarkers: any[] = [];
  private taskMarkerDepots: any[] = [];
  private routedMarkersControl: any = {};
  private relatedMarkersControl: any = {};
  private relatedPolylinesControl: any = {};
  private static: boolean = true;
  public logisticsVehiclesDataLayerRef: any;

  private mapInstance = undefined;
  private polylineCopy = undefined;
  private drawing = false;
  private drawingFromMarkerId = undefined;
  private firstCoords: any;
  public markerEvents: any;
  public polyline: any = {
    path: [],
    visible: true,
    stroke: {
      color: '#424242',
      weight: 2,
      opacity: 1
    }
    // icons: [{
    //     icon: {
    //         path: google.maps.SymbolPath.BACKWARD_OPEN_ARROW
    //     },
    //     offset: '50px',
    //     repeat: '150px'
    // }]
  };
  public polylineDraw: any = {
    path: [],
    visible: true,
    clickable: false,
    stroke: {
      color: '#FBB446',
      weight: 3,
      opacity: 0.7
    }
  };
  private relatedPolylines: any[] = [];
  private filters: any = {
    agent: {
      enabled: true
    },
    showAgentsWithoutGpsPermissions: {
      enabled: true
    },
    geoRoutes: {
      enabled: true
    },
    routes: {
      enabled: true
    },
    traffic: {
      enabled: false
    },
    satellite: {
      enabled: false
    },
    geofencing: {
      enabled: false
    },
    irregularities: {
      enabled: true
    },
    actualTracking: {
      enabled: true
    }
  };
  private taskMarkersLayer: any;
  private relatedTaskMarkersLayer: any;
  private taskInfoWindowModel: any;
  private circleTypes: any;
  private circles: any;
  private polygonEvents: any;
  public geoRoutesDataLayerRef: any;
  public routesDataLayerRef: any;
  public irregularitiesDataLayerRef: any;
  public irregularityInfoWindowModel;
  public irregularityInfoWindow;
  public distanceUnit: string;
  public actualTrackingDataLayerRef: any;
  public actualTrackingInfoWindowModel: any;
  public actualTrackingInfoWindow: any;

  constructor(private $task, private mapsCommonService: MapsCommonService, private resizeService: ResizeService,
              private itinerariesConstant, private $mdMedia, private uiGmapIsReady,
              private moment, private splitService: SplitService, private agentsService: AgentsService,
              private $depots, private $filter, private mapFactoryService: MapFactoryService, private $timeout: ITimeoutService, private $mdColors) {
   this.filters.showAgentsWithoutGpsPermissions.enabled = !this.splitService.getEnableLocationTrackingFilterByDefault();
  }

  $onInit() {
    this.distanceUnit = this.splitService.getSiteDistanceLargeUnit();
    this.infowindow = new google.maps.InfoWindow({
      pixelOffset: new google.maps.Size(0, -20)
    });
    this.infowindow.setOptions({disableAutoPan: true});
    this.inActiveStatuses = this.itinerariesConstant.inActiveTaskStatuses;
    this.siteLocation = this.mapsCommonService.getSiteLocation();
    this.taskInfoWindow = this.mapsCommonService.initActiveWindow({
      pixelOffset: new google.maps.Size(0, -40),
      disableAutoPan: false,
    });
    this.actualTrackingInfoWindow = this.mapsCommonService.initActiveWindow({
      pixelOffset: new google.maps.Size(0, -40),
      disableAutoPan: false,
    });
    this.polylineInfoWindow = this.mapsCommonService.initActiveWindow({
      pixelOffset: new google.maps.Size(0, 40),
      disableAutoPan: false
    });
    this.map = {
      isReady: false,
      center: this.siteLocation,
      zoom: 12,
      events: {
        idle: (map) => {
          if (!this.map.isReady) {
            this.mapRef = map;
            this.map.isReady = true;
            google.maps.event.trigger(map, 'resize');
            this.resizeService.resize();
            this.centerMap();
          }
          this.polylineInfoWindow.show = false;
        },
        click: () => {
          if (!this.$mdMedia('gt-md')) {
            this.$timeout(0).then(() => {
              this.infowindow.close();
              this.onHighlightedChanged({
                serviceId: undefined,
                taskId: undefined
              });
            })
          }
        },
        mousemove: (map, eventName, events, test3) => {
          const isDesktop = this.$mdMedia('gt-sm');
          if (this.drawing && isDesktop) {
            this.polylineDraw.path = [
              this.firstCoords, {latitude: events[0].latLng.lat(), longitude: events[0].latLng.lng()}
            ];

            this.polylineInfoWindow.show = true;
            this.polylineInfoWindow.coords = {latitude: events[0].latLng.lat(), longitude: events[0].latLng.lng()};
            this.$timeout(0).then(() => {
            })
          }
        }
      },
      options: {
        styles: this.mapsCommonService.getDefaultStyle(),
        mapTypeControl: false,
        scaleControl: true,
        mapTypeId: google.maps.MapTypeId[this.mapTypeIds.roadmap]
      },
      bounds: {},
      taskMarkersLayerEnabled: true,
      relatedTaskMarkersLayerEnabled: true,
      logisticsVehiclesLayerEnable: true,
      geoRoutesLayerEnabled: true,
      geoRoutesLayerCallback: (layer) => {

        this.geoRoutesDataLayerRef = layer;

        if (this.geoRoutes) {
          this.setAgentGeoRoutes(this.geoRoutes);
        }
      },
      routesLayerEnabled: true,
      irregularitiesLayerEnabled: true,
      routesLayerCallback: (layer) => {

        this.routesDataLayerRef = layer;

        if (this.routes) {
          this.setRoutes(this.routes);
        }
      },
      irregularitiesLayerCallback: (layer) => {

        this.irregularitiesDataLayerRef = layer;

        // Layer - Mouseover
        this.irregularitiesDataLayerRef.addListener("mouseover", (event) => {
          const irregularityType = event.feature.getProperty("type");

          if (irregularityType === 'outOfServiceAreaIrregularity') {
            this.$timeout(0).then(() => {
              const ref = angular.copy(event.feature.getProperty("ref"));
              const geo = event.feature.getGeometry().get();
              this.setIrregularityInfoWindow(ref, irregularityType, geo.lat(), geo.lng());
            })
          }

          if (irregularityType === 'taskCompletionLocationIrregularity') {
            const irregularityRef = angular.copy(event.feature.getProperty("ref"));
            this.$timeout(0).then(() => {
              const taskIndex = this.tasks.findIndex(t => t.id === irregularityRef.taskId);
              const ref = {...angular.copy(event.feature.getProperty("ref")), taskNumber: taskIndex + 1};
              const geo = event.feature.getGeometry().get();
              this.setIrregularityInfoWindow(ref, irregularityType, geo.lat(), geo.lng());
            })
          }

        });

        // Layer - Mouseout
        this.irregularitiesDataLayerRef.addListener("mouseout", (event) => {
          this.$timeout(0).then(() => {
            this.unsetIrregularityInfoWindow();
          });
        });

        if (!!this.irregularities) {
          this.setIrregularities(this.irregularities);
        }

      },
      actualTrackingLayerEnabled: true,
      actualTrackingLayerCallback: (layer) => {
        this.actualTrackingDataLayerRef = layer;

        // Mouse Over
        this.actualTrackingDataLayerRef.addListener("mouseover", (event) => {
          this.$timeout(0).then(() => {
            const ref = angular.copy(event.feature.getProperty("ref"));
            const geo = event.feature.getGeometry().get();
            this.setActualTrackingInfoWindow(ref, geo.lat(), geo.lng());
          });
        });

        // Mouse Out
        this.actualTrackingDataLayerRef.addListener("mouseout", () => {
          this.$timeout(0).then(() => {
            this.unsetActualTrackingInfoWindow();
          });
        });

        if (!!this.actualTrackingStops) {
          this.setActualTrackingStops(this.actualTrackingStops);
        }
      },
      taskMarkersLayerCallback: (layer) => {
        this.taskMarkersLayer = layer;

        // Add events connection to data layer

        // Click
        this.taskMarkersLayer.addListener("click", (event) => {
          this.$timeout(0).then(() => {
            if (!this.$mdMedia('gt-md')) {
              const taskId = event.feature.getProperty("id");
              const serviceId = event.feature.getProperty("serviceId");

              //Highlight Tasks
              this.$timeout(0).then(() => {
                this.onHighlightedChanged({
                  serviceId: serviceId,
                  taskId: taskId
                });
              });
            }
          })
        });

        // Mouse Over
        this.taskMarkersLayer.addListener("mouseover", (event) => {
          const taskId = event.feature.getProperty("id");
          const serviceId = event.feature.getProperty("serviceId");

          //Highlight Tasks
          this.$timeout(0).then(() => {
            this.onHighlightedChanged({
              serviceId: serviceId,
              taskId: taskId
            });
          });
        });

        // Mouse Out
        this.taskMarkersLayer.addListener("mouseout", (event) => {
          this.$timeout(0).then(() => {
            this.onHighlightedChanged({
              serviceId: undefined,
              taskId: undefined
            });
          });
        });

        if (_.get(this.tasks, 'length')) {
          this.setTaskMarkers(this.tasks, true);
        }

      },
      layerEnable: true
    };
    this.agentMarker = {
      options: {
        icon: this.mapsCommonService.getAgentIcon(this.agent),
        visible: true,
        draggable: this.agentDraggable || false
      }
    };
    this.agentEvents = {
      click: (marker, event, model, args) => {
        this.initAgentInfoWindow(marker, model);
      },
      mouseover: (marker, event, model, args) => {
        this.initAgentInfoWindow(marker, model);
      },
      mouseout: (marker, event, model, args) => {
        if (this.infowindow) {
          this.infowindow.close();
        }
      }
    };
    this.depotEvents = {
      click: (marker, event, model, args) => {
        this.initDepotInfoWindow(marker, model);
      },
      mouseover: (marker, event, model, args) => {
        this.initDepotInfoWindow(marker, model);
      },
      mouseout: (marker, event, model, args) => {
        if (this.infowindow) {
          this.infowindow.close();
        }
      }
    };
    this.polygonEvents = {
      mouseover: (marker, event, model) => {
        if (!this.infowindow) return; // Safety check
        const map = marker.map;
        const contentString =
          '<div style="text-align: center; width: 100%">' + escapeHtml(_.get(model, 'fill.name')) + '</div>';
        this.infowindow.setPosition(this.mapsCommonService.getPolygonBounds(model.path).getCenter());
        this.infowindow.setContent(contentString);
        this.infowindow.open(map, marker);
      },
      mouseout: () => {
        if (!this.infowindow) return; // Safety check
        this.infowindow.close();
      }
    };

    this.taskMarkers = [];
    this.polyline.path = [];
    this.taskMarkerDepots = [];
    // this.relatedPolyline.path = [];

    if (!!this.agent) {
      this.agentMarker = this.mapsCommonService.buildAgentMarker(this.agent, this.filters.agent.enabled, this.filters.showAgentsWithoutGpsPermissions.enabled, this.agentLocationCoords);
      this.circleTypes = this.mapsCommonService.getTasksRadiusPayload(this.agent);
      this.onGeofancingChange(this.filters.geofencing.enabled);
    }


    // For Edit Mode

    this.markerEvents = {
      mousedown: (marker, event, model, args) => {
        this.mapInstance = marker.map;
        const map = marker.map;
        this.drawing = true;
        this.drawingFromMarkerId = model.id;
        this.firstCoords = {latitude: marker.position.lat(), longitude: marker.position.lng()};
        map.setOptions({draggable: false, zoomControl: false, scrollwheel: false, disableDoubleClickZoom: true});
      },
      mouseover: (marker, event, model, args) => {
        if (this.drawing && this.drawingFromMarkerId !== model.id) {

          const filteredTaskMarkers = _.filter(this.taskMarkers, (m) => {
            return m.id !== model.id;
          });
          const drawingFromMarkerIndex = _.findIndex(filteredTaskMarkers, (m) => {
            return m.id === this.drawingFromMarkerId;
          });
          const requestedTaskIndex = drawingFromMarkerIndex + 1;
          filteredTaskMarkers.splice(requestedTaskIndex, 0, model);

          const updatedTaskMarkers = filteredTaskMarkers;

          const complementaryTaskIndex = _.findIndex(updatedTaskMarkers, (m) => {
            return m.serviceId === model.serviceId && m.id !== model.id;
          });

          if (!complementaryTaskIndex ||
            (model.purpose === 'Pickup' && requestedTaskIndex < complementaryTaskIndex) ||
            (model.purpose === 'Dropoff' && requestedTaskIndex > complementaryTaskIndex) ||
            model.purpose === 'Operation') {

            this.polylineCopy = angular.copy(this.polyline);
            this.polyline.path = this.getPolylinePath(updatedTaskMarkers);
          }

        }
      },
      mouseout: (marker, event, model, args) => {
        if (this.drawing && this.polylineCopy) {
          this.polyline = this.polylineCopy;
          this.polylineCopy = undefined;
        }
      }
    };

    this.mapFactoryService.getBrowserLocation()
      .then((res: any) => {
        this.myLocation = this.mapsCommonService.buildMyLocationMarker(res.coords);
      })
      .catch((err) => {

      })


    // Edit Mode Line
    this.polyline = {
      path: [],
      visible: true,
      stroke: {
        color: this.$mdColors.getThemeColor('red-300'),
        weight: 2,
        opacity: 0.7
      },
      icons: [{
        icon: {
          path: google.maps.SymbolPath.BACKWARD_OPEN_ARROW
        },
        offset: '50px',
        repeat: '150px'
      }]
    };

    // this.uiGmapIsReady.promise(1).then((maps) => {
    //   // Init drawing listener
    //   this.mapInstance = maps[0].map.controls.getGMap();
    //   google.maps.event.addListener(this.mapInstance, 'mousemove', (event) => {
    //     const isDesktop = this.$mdMedia('gt-sm');
    //     if (this.drawing && isDesktop) {
    //       this.polylineDraw.path = [
    //         this.firstCoords, {latitude: event.latLng.lat(), longitude: event.latLng.lng()}
    //       ];
    //       this.$timeout(0).then(() => {
    //       })
    //     }
    //   });
    // });

    this.centerMap();
  }

  $onChanges(changes) {
    //Agent changed
    if ((changes.agent && !changes.agent.isFirstChange())) {
      const currentAgent = changes.agent.currentValue,
        previousAgent = changes.agent.previousValue;

      this.agentMarker = this.mapsCommonService.buildAgentMarker(this.agent, this.filters.agent.enabled, this.filters.showAgentsWithoutGpsPermissions.enabled, this.agentLocationCoords);

      if (!!currentAgent) {
        this.circleTypes = this.mapsCommonService.getTasksRadiusPayload(currentAgent);
        this.onGeofancingChange(this.filters.geofencing.enabled);
      }

      if (_.get(currentAgent, 'id') !== _.get(previousAgent, 'id')) {
        this.centerMap();
      }
    }

    if(changes.agentLocationCoords && !changes.agentLocationCoords.isFirstChange() && !!this.agent) {

      this.agentMarker = this.mapsCommonService.buildAgentMarker(this.agent, this.filters.agent.enabled, this.filters.showAgentsWithoutGpsPermissions.enabled, this.agentLocationCoords);
    }

    if ((changes.tasks && !changes.tasks.isFirstChange()) ||
      (changes.irregularities && !changes.irregularities.isFirstChange())) {
      const currentTasks = _.get(changes, 'tasks.currentValue', []),
        previousTasks = _.get(changes, 'tasks.previousValue', []);

      if (!!previousTasks.length) {
        // this.removeTasksFromDataLayer(_.flatMap(previousTasks, 'agentId'));
        this.removeTasksFromDataLayer();
      }

      if (!!currentTasks.length) {
        const doCenterMap = !_.get(previousTasks, 'length');
        this.setTaskMarkers(currentTasks, doCenterMap);
      }

      this.irregularitiesDataLayerRef?.forEach((feature) => {
        this.irregularitiesDataLayerRef.remove(feature);
      });

      if (!!this.irregularities) {
        this.setIrregularities(this.irregularities);
      }

    }

    //Task clicked (Active window)
    if (changes.highlightedTaskId && !changes.highlightedTaskId.isFirstChange()) {
      const currentHighlightedTaskId = changes.highlightedTaskId.currentValue,
        previousHighlightedTaskId = changes.highlightedTaskId.previousValue;
      if (!_.isEqual(currentHighlightedTaskId, previousHighlightedTaskId)) {
        let taskForHighlight = _.find(this.tasks, (t) => {
          return _.isEqual(t.id, currentHighlightedTaskId);
        });


        if (!taskForHighlight) {
          taskForHighlight = _.find(this.relatedTaskMarkers, (marker) => {
            return _.isEqual(marker.id, currentHighlightedTaskId);
          });
        }

        this.setTaskInfoWindow(taskForHighlight);

        this.resetTaskMarkersLayerStyle();
      }
    }

    //Task clicked (Active window)
    if (changes.highlightedIrregularityId && !changes.highlightedIrregularityId.isFirstChange()) {
      const currentHighlightedIrregularityId = changes.highlightedIrregularityId.currentValue,
        previousHighlightedIrregularityId = changes.highlightedIrregularityId.previousValue;
      if (!_.isEqual(currentHighlightedIrregularityId, previousHighlightedIrregularityId)) {

        if (!currentHighlightedIrregularityId && !!this.irregularityInfoWindow) {
          this.irregularityInfoWindow.show = false;
        } else {
          this.irregularitiesDataLayerRef.forEach((feature) => {
            const id = feature.getProperty('id');

            if (id === currentHighlightedIrregularityId) {
              const irregularityRef = feature.getProperty("ref");
              const irregularityType = feature.getProperty("type");
              this.$timeout(0).then(() => {
                const taskIndex = this.tasks.findIndex(t => t.id === irregularityRef.taskId);
                const ref = {...angular.copy(feature.getProperty("ref")), taskNumber: taskIndex + 1};
                const geo = feature.getGeometry().get();
                this.setIrregularityInfoWindow(ref, irregularityType, geo.lat(), geo.lng());
              })
            }
          });
        }
      }
    }

    //Task clicked (Active window)
    if (changes.selectedTaskId && !changes.selectedTaskId.isFirstChange()) {
      this.centerMap();
      this.resetTaskMarkersLayerStyle();
    }

    if (changes.hiddenAgentIds && !changes.hiddenAgentIds.isFirstChange()) {

      // Set feature style by its properties

      if (this.taskMarkersLayer) {
        this.resetTaskMarkersLayerStyle();
      }


    }

    if (changes.geoRoutes) {
      if (this.geoRoutesDataLayerRef) {
        this.geoRoutesDataLayerRef.forEach((feature) => {
          this.geoRoutesDataLayerRef.remove(feature);
        });

        this.setAgentGeoRoutes(this.geoRoutes);
      }
    }

    if (changes.routes) {
      if (this.routesDataLayerRef) {
        this.routesDataLayerRef.forEach((feature) => {
          this.routesDataLayerRef.remove(feature);
        });

        this.setRoutes(this.routes);
      }
    }

    if (changes.actualTrackingStops && !changes.actualTrackingStops.isFirstChange()) {
      if (this.actualTrackingDataLayerRef) {
        this.actualTrackingDataLayerRef.forEach((feature) => {
          this.actualTrackingDataLayerRef.remove(feature);
        });

        if (!!this.actualTrackingStops) {
          this.setActualTrackingStops(this.actualTrackingStops);
        }
      }
    }
  }

  onGeofancingChange(isEnabled) {
    this.circles = [];
    if (isEnabled) {

      this.taskMarkersLayer.forEach((feature) => {
        const address = feature.getProperty('address');

        if (address && address.location) {
          const taskCircles = angular.copy(this.circleTypes);
          taskCircles[0].center = address.location;
          taskCircles[1].center = address.location;
          this.circles = this.circles.concat(taskCircles);
        }
      });

    }
  }

  onMapTypeChange(isSatelliteEnabled) {
    this.map.options.mapTypeId = google.maps.MapTypeId[isSatelliteEnabled ? this.mapTypeIds.satellite : this.mapTypeIds.roadmap];
    if (isSatelliteEnabled) {
      this.filters.traffic.enabled = false;
    }
  }

  onToggleAgentsByGpsPermissionsChange() {
    this.agentMarker.options.visible = !this.filters.showAgentsWithoutGpsPermissions.enabled ?
      (this.filters.agent.enabled && this.agentsService.doesAgentHasGpsPermissions(this.agent)) :
      !!this.filters.agent.enabled;
  }

  centerMap() {
    const markers = this.getAllMarkers();
    this.$timeout(0).then(() => {
      this.mapsCommonService.centerMapByBounds(this.map, markers);
      if (this.selectedTaskId && this.mapRef) {
        this.$timeout(() => {
          this.mapRef.setZoom(12);
        }, 0);
      } else if (this.isCenterByAgent && this.mapRef) {
        this.$timeout(() => {
          this.mapRef.setZoom(10);
        }, 0);
      }
    });
  }

  // function sortTaskMarkers(taskMarkers, taskIds) {
  //   return _.sortBy(taskMarkers, [function (taskMarker) {
  //     var index = _.indexOf(taskIds, taskMarker.id) + 1;
  //     return index - 1;
  //   }]);
  // }

  getPolylinePath(allMarkers) {
    let path = [];
    _.forEach(allMarkers, (marker) => {
      path.unshift(
        {
          latitude: marker.coords.latitude,
          longitude: marker.coords.longitude,
          id: marker.id
        }
      )
    });
    return path;
  }

  // toggleShowItinerary(isEnabled) {
  //   let hiddenAgentIdsCopy = angular.copy(this.hiddenAgentIds);
  //   if (isEnabled) {
  //     hiddenAgentIdsCopy = _.filter(this.hiddenAgentIds, (id) => {
  //       return id !== this.agent.id;
  //     })
  //   } else {
  //     hiddenAgentIdsCopy.push(this.agent.id);
  //   }
  //   this.onHiddenAgentIdsChange({ids: _.uniq(hiddenAgentIdsCopy)});
  // }

  onTaskMarkerClick(marker, eventName, model) {
    //Highlight Tasks
    this.onHighlightedChanged({
      serviceId: model.serviceId,
      taskId: model.id
    });
  }

  setTaskInfoWindow(task: TaskModel) {
    if (task) {
      const location = _.get(task, 'taskSpec.address.location');
      this.taskInfoWindow.show = true;
      this.taskInfoWindow.coords = {
        lat: location?.lat,
        latitude: location?.lat,
        lng: location?.lng,
        longitude: location?.lng
      };
      this.taskInfoWindowModel = task;
    } else {
      // this.taskInfoWindow.show = false;
      this.taskInfoWindowModel = undefined;
    }
  }


  private setTaskMarkers(tasks, doCenterMap) {
    if (this.taskMarkersLayer) {
      const geoJson = this.mapsCommonService.convertRoutedTasksToGeoJson(tasks, _.get(this, 'agent.id'), this.isUseDaySequenceAsTaskIndex, true);

      // Add routes to layer
      this.taskMarkersLayer.addGeoJson(geoJson);

      // Set feature style by its properties
      this.resetTaskMarkersLayerStyle();

      if (doCenterMap) {
        this.centerMap();
      }
    }
  }

  private setIrregularities(irregularities) {

    if (this.irregularitiesDataLayerRef) {

      const geoJson = this.mapsCommonService.agentIrregularityGeoJson(this.irregularities, this.irregularities.agentId);

      this.irregularitiesDataLayerRef.addGeoJson(geoJson);

      // Set feature style by its properties
      this.irregularitiesDataLayerRef.setStyle((feature) => {
        return this.mapsCommonService.getAgentIrregularityFeatureStyle();
      });
    }
  }

  private setActualTrackingStops(stops) {
    if (this.actualTrackingDataLayerRef) {
      const geoJson = this.mapsCommonService.convertActualTrackingToGeoJson(stops);

      this.actualTrackingDataLayerRef.addGeoJson(geoJson);

      this.actualTrackingDataLayerRef.setStyle((feature) => {
        return this.mapsCommonService.getActualTrackingFeatureStyle(feature);
      });
    }
  }

  private setActualTrackingInfoWindow(ref, lat, lng) {
    this.actualTrackingInfoWindow.show = true;
    this.actualTrackingInfoWindow.coords = { lat: lat, latitude: lat, lng: lng, longitude: lng };
    this.actualTrackingInfoWindowModel = ref;
  }

  private unsetActualTrackingInfoWindow() {
    this.actualTrackingInfoWindow.show = false;
    this.actualTrackingInfoWindowModel = undefined;
  }


  private resetTaskMarkersLayerStyle() {
    this.taskMarkersLayer.setStyle((feature) => {
      // const updatedVisible = !_.includes(this.hiddenAgentIds, feature.getProperty('agentId'));
      // const currentVisible = feature.getProperty('visible');

      const taskPurpose = feature.getProperty('purpose');
      const taskId = feature.getProperty('id');
      let taskColor;
      if (taskPurpose === TaskPurposeType.Pickup) {
        taskColor = '#FA8C32';
      } else if (taskPurpose === TaskPurposeType.Dropoff) {
        taskColor = '#20ADF3';
      } else if (taskPurpose === TaskPurposeType.Operation) {
        taskColor = '#2EBDA4'
      }
      return this.mapsCommonService.getAgentPerformanceTaskFeatureStyle(feature, true, taskColor, this.selectedTaskId === taskId, this.highlightedTaskId === taskId);

      // if (!_.isEqual(currentVisible, updatedVisible)) {
      //   const taskPurpose = feature.getProperty('purpose');
      //   const taskId = feature.getProperty('id');
      //   let taskColor;
      //   if (taskPurpose === TaskPurposeType.Pickup) {
      //     taskColor = '#FA8C32';
      //   } else if (taskPurpose === TaskPurposeType.Dropoff) {
      //     taskColor = '#20ADF3';
      //   } else if (taskPurpose === TaskPurposeType.Operation) {
      //     taskColor = '#2EBDA4'
      //   }
      //   return this.mapsCommonService.getAgentPerformanceTaskFeatureStyle(feature, updatedVisible, taskColor,this.selectedTaskId === taskId , false);
      // }
    });
  }

  private initTaskMarkerDepots(depotIds) {
    this.$depots().$asyncValues(depotIds)
      .then((depots) => {
        this.taskMarkerDepots = this.mapsCommonService.getDepotMarkers(depots);
      })
  }

  private getAllMarkers() {
    let markers = [];

    if (!!this.selectedTaskId) {
      const task = this.tasks.find(t => t.id === this.selectedTaskId);
      const fakeMarker = new google.maps.MVCObject();
      fakeMarker.set('coords', {'latitude': task.taskSpec.address.location.lat, 'longitude': task.taskSpec.address.location.lng});
      markers.push(fakeMarker);
    } else if (this.isCenterByAgent && !_.isUndefined(this.agentMarker)) {
      if (this.agentMarker.coords) {
        const fakeMarker = new google.maps.MVCObject();
        fakeMarker.set('coords', this.agentMarker.coords);
        markers.push(fakeMarker);
      }
    } else {

      if (!_.isUndefined(this.taskMarkersLayer)) {
        this.taskMarkersLayer.forEach((feature) => {
          const address = feature.getProperty('address');

          if (address && address.location) {
            const fakeMarker = new google.maps.MVCObject();
            fakeMarker.set('coords', {'latitude': address.location.lat, 'longitude': address.location.lng});
            markers.push(fakeMarker);
          }
        });
      }
      if (!_.isUndefined(this.relatedTaskMarkersLayer)) {
        this.relatedTaskMarkersLayer.forEach((feature) => {
          const address = feature.getProperty('address');

          if (address && address.location) {
            const fakeMarker = new google.maps.MVCObject();
            fakeMarker.set('coords', {'latitude': address.location.lat, 'longitude': address.location.lng});
            markers.push(fakeMarker);
          }
        });
      }


    }

    return markers;
  }

  private getAllAgentIds() {
    const agentIds = _.map(this.relatedPolylines, 'agentId')
    if (_.get(this.agent, 'id')) {
      agentIds.push(this.agent.id);
    }
    return agentIds;

  }

  private setMarkersVisibility(markers, isFilterOn) {
    _.forEach(markers, (m) => {
      m.setVisible(isFilterOn ? !_.includes(this.hiddenAgentIds, m.model.agentId) : false);
    });
  }

  private initAgentInfoWindow(marker, model) {
    if (!this.infowindow) return; // Safety check
    const map = marker.map;
    this.infowindow.setContent(escapeHtml(this.$filter('userName')(_.get(model, 'options.ref.user'))));
    this.infowindow.open(map, marker);
  }

  private initDepotInfoWindow(marker, model) {
    if (!this.infowindow) return; // Safety check
    const map = marker.map;
    this.infowindow.setContent(escapeHtml(_.get(model, 'name')));
    this.infowindow.open(map, marker);
  }

  private removeTasksFromDataLayer(removeByAgentIds?) {
    if (this.taskMarkersLayer) {
      this.taskMarkersLayer.forEach((feature) => {
        if (_.get(removeByAgentIds, 'length')) {
          var featureAgentId = feature.getProperty('agentId');
          if (_.includes(removeByAgentIds, featureAgentId)) {
            this.taskMarkersLayer.remove(feature);
          }
        } else {
          this.taskMarkersLayer.remove(feature);
        }
      });
    }
  }

  onMouseUp(event) {
    if (this.drawing) {

      this.polylineDraw.path = [];
      this.drawing = false;
      this.drawingFromMarkerId = undefined;

      this.mapInstance.setOptions({
        draggable: true,
        zoomControl: true,
        scrollwheel: true,
        disableDoubleClickZoom: true
      });

      this.map.options.draggable = true;
      this.map.options.zoomControl = true;
      this.map.options.scrollwheel = true;
      this.map.options.disableDoubleClickZoom = true;

      const startDay = _.find(this.tasks, (t) => {
        return t.taskSpec.purpose === 'StartDay'
      })
      const endDay = _.find(this.tasks, (t) => {
        return t.taskSpec.purpose === 'EndDay'
      })

      if (this.polylineCopy) {
        const taskIds = _
          .chain(this.polyline.path)
          .map((path) => {
            return path.id;
          })
          .reverse()
          .value();

        this.polylineCopy = undefined;

        if (startDay) {
          taskIds.unshift(startDay.id)
        }
        if (endDay) {
          taskIds.push(endDay.id)
        }

        this.onTasksOrderChange({taskIds: taskIds});
      }

    } else {
      this.polylineInfoWindow.show = false;
      this.map.options.draggable = true;
      this.map.options.zoomControl = true;
      this.map.options.scrollwheel = true;
      this.map.options.disableDoubleClickZoom = true;
    }
  }

  private setAgentGeoRoutes(routes) {
    if (this.geoRoutesDataLayerRef) {

      const geoRoutesPolylineGeoJson = this.mapsCommonService.convertRoutesPolylineToGeoJson(routes, '#266AFF');

      // Add routes to layer
      this.geoRoutesDataLayerRef.addGeoJson(geoRoutesPolylineGeoJson);

      // Set feature style by its properties
      this.setGeoRoutesStyle();

    }
  }

  private setRoutes(routes) {
    if (this.routesDataLayerRef) {

      const agentRoutesPolylinesGeoJson = this.mapsCommonService.convertRoutesPolylineToGeoJson(routes, '#F8A72D80');

      // Add routes to layer
      this.routesDataLayerRef.addGeoJson(agentRoutesPolylinesGeoJson);

      // Set feature style by its properties
      this.setRoutesStyle();

    }
  }

  private setGeoRoutesStyle() {
    if (this.geoRoutesDataLayerRef) {
      this.geoRoutesDataLayerRef.setStyle((feature) => {
        return this.mapsCommonService.getRoutePolylineFeatureStyle(feature, {
          strokeOpacity: 2,
          dottedLine: false,
          displaySquare: true
        });
      });
    }
  }

  private setRoutesStyle() {
    if (this.routesDataLayerRef) {
      this.routesDataLayerRef.setStyle((feature) => {
        return this.mapsCommonService.getRoutePolylineFeatureStyle(feature, {
          strokeWeight: 6,
          strokeOpacity: 1,
          dottedLine: false
        });
      });
    }
  }

  private setIrregularityInfoWindow(ref, type, lat, lng) {
    this.irregularityInfoWindow = {};
    this.irregularityInfoWindow.coords = {
      lat: lat,
      latitude: lat,
      lng: lng,
      longitude: lng
    };

    this.irregularityInfoWindowModel = {
      ref: ref,
      type: type,
      distanceUnit: this.distanceUnit
    };
    this.irregularityInfoWindow.show = true;
  }

  private unsetIrregularityInfoWindow() {
    this.irregularityInfoWindowModel = undefined;
    this.irregularityInfoWindow.show = false;
  }


}

angular
  .module('bringoz.admin.map')
  .component('agentPerformanceMap', {
    bindings: {
      agent: '<',
      agentLocationCoords: '<?',
      tasks: '<',
      irregularities: '<?',
      selectedTaskId: '<?',
      highlightedTaskId: '<',
      highlightedIrregularityId: '<?',
      agentDraggable: '<?',
      hiddenAgentIds: '<',
      isUseDaySequenceAsTaskIndex: '<',
      isCenterByAgent: '<?',
      geoRoutes: '<?',
      routes: '<?',
      actualTrackingStops: '<?',
      generalizedLocationCircles: '<?',
      onHighlightedChanged: '&',
      onHiddenAgentIdsChange: '&',
      onAgentLocationChange: '&',
      onTasksOrderChange: '&',
      taskTooltipTemplateUrl: '<?'
    },
    template: require('./agent-performance-map.html').default,
    controller: AgentPerformanceMapComponent
  });

